import "./LearnHero.css";
import { useTranslation } from "../i18n";

function LearnHero() {
    const { t } = useTranslation();

    return (
        <div className="learn-hero">
            <div className="overlay"></div>
            <div className="learn-hero-container">
                {/* Primera columna: Contenido */}
                <div className="learn-hero-content">
                    <h2>{t("learn.heroKicker")}</h2>
                    <h1>{t("learn.heroTitle")}</h1>
                    <div className="underline"></div>
                    <p>{t("learn.heroText")}</p>
                    <p>Cypress | Selenium | Appium  | Playwright </p>
                </div>
            </div>
        </div>
    );
}

export default LearnHero;
